export function validationParams(params) {
	let validateResult = {};

	Object.keys(params).forEach((item) => {
		if (params[item]) {
			validateResult = {
				...validateResult,
				[item]: params[item],
			};
		}
	});

	return validateResult;
}
